// extracted by mini-css-extract-plugin
module.exports = {"switcher":"HeroSwitcher_switcher__gSIk1","segment":"HeroSwitcher_segment__K8mY_","segmentActive":"HeroSwitcher_segmentActive__OU5vS"};